'use client';

import { useGetCustomer } from '@/hooks/use-customer-api';
import { useMyClassRoute } from '@/hooks/use-my-class-route';
import { usePathname } from '@/i18n/routing';
import SupportNumberFab from '../support-number/support-number-fab';
import WhatsappChatSupport from './whatsapp-chat-support';

export default function SupportActions() {
  const { customer } = useGetCustomer();
  const { isMyClassRoute } = useMyClassRoute();
  const pathName = usePathname();
  const isCourseSuccessScreen = pathName.includes('/purchase-success');

  if (
    !customer ||
    isMyClassRoute ||
    isCourseSuccessScreen ||
    (!customer.whatsappSupportPhone && !customer.supportPhone)
  ) {
    return null;
  }

  return (
    <div className="fixed bottom-28 md:bottom-10 right-4 md:right-8 z-50 flex flex-col gap-4">
      {customer?.whatsappSupportPhone && (
        <WhatsappChatSupport
          whatsappSupportPhone={customer.whatsappSupportPhone}
        />
      )}
      {customer?.supportPhone && (
        <SupportNumberFab supportPhone={customer.supportPhone} />
      )}
    </div>
  );
}
